module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-wrapper"
  }, [(_vm.isSelf && _vm.mainScreenData && _vm.mainScreenData.cameraStatus !== 0) ? _c('div', {
    staticClass: "mainscreen-self",
    attrs: {
      "id": _vm.selfContainerId
    }
  }) : (_vm.isSelf && (!_vm.mainScreenData || _vm.mainScreenData.cameraStatus === 0)) ? _c('div', {
    staticClass: "mainscreen-bg"
  }, [_c('img', {
    staticClass: "mainscreen-bg-img",
    attrs: {
      "src": _vm.mainScreenData && _vm.mainScreenData.userInfo && _vm.mainScreenData.userInfo.headPortrait,
      "alt": ""
    }
  })]) : (!_vm.isSelf && _vm.mainScreenData && _vm.mainScreenData.cameraStatus !== 0) ? _c('div', {
    staticClass: "mainscreen-pull"
  }, [_c('video', {
    staticClass: "zb-video",
    staticStyle: {
      "object-fit": "cover"
    },
    attrs: {
      "id": _vm.playerId,
      "preload": "auto",
      "playsinline": "",
      "webkit-playsinline": ""
    }
  }), _vm._v(" "), (!_vm.isPlaying) ? _c('div', {
    staticClass: "mainscreen-video-cover"
  }, [_c('div', {
    staticClass: "mainscreen-video-cover-box"
  }, [_c('img', {
    staticClass: "mainscreen-video-cover-img",
    attrs: {
      "src": _vm.mainScreenData && _vm.mainScreenData.userInfo && _vm.mainScreenData.userInfo.headPortrait,
      "alt": ""
    }
  })])]) : _vm._e()]) : _c('div', {
    staticClass: "mainscreen-bg"
  }, [_c('img', {
    staticClass: "mainscreen-bg-img",
    attrs: {
      "src": _vm.mainScreenData && _vm.mainScreenData.userInfo && _vm.mainScreenData.userInfo.headPortrait,
      "alt": ""
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5620b7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainscreenplayer/mainscreenplayer.vue
// module id = 1045
// module chunks = 1